export default function({numberLocale}) {
  return {
    formatNumber(number, render) {
      return Number(render(number)).toLocaleString(numberLocale);
    },
  };
}



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/lib/createHelpers.js